export const getCookie = (cname: string): string | null => {
  const name = cname + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return null
}

/**
 * Mapa de padrões de hostname para seus respectivos domínios
 * Usado para determinar qual domínio deve ser definido para o cookie
 */
const DOMAIN_PATTERNS = {
  'prevteste.com': 'prevteste.com',
  'prev2': 'prev2.app',
  'prevhml': 'prevhml.app',
  'prevfeature': 'prevfeature.app',
  'localhost': (hostname: string) => hostname, // Para localhost, usa o próprio hostname
  'prevqa': 'prevqa.app',
  'prev-dashboard-v2.s3-website-us-east-1.amazonaws.com': 'prev-dashboard-v2.s3-website-us-east-1.amazonaws.com',
  // Padrão para produção ou qualquer outro caso
  'default': 'prev.app'
};

/**
 * Determina o domínio do cookie com base no hostname atual
 * @param hostname - O hostname atual do navegador
 * @returns {string} O domínio apropriado para definir o cookie
 */
export const getDomainFromHostname = (hostname: string): string => {
  // Procura no mapa de padrões o domínio apropriado
  for (const [pattern, domain] of Object.entries(DOMAIN_PATTERNS)) {
    if (hostname.includes(pattern)) {
      // Se o valor for uma função, executa a função passando o hostname
      if (typeof domain === 'function') {
        return domain(hostname);
      }
      return domain;
    }
  }

  // Retorna o domínio padrão se nenhum padrão corresponder
  return DOMAIN_PATTERNS.default;
};

/**
 * Define um cookie que funciona em todos os subdomínios do domínio atual
 * 
 * @param name - O nome do cookie a ser definido
 * @param value - O valor a ser armazenado no cookie
 * @param days - O número de dias até que o cookie expire
 * 
 * @example
 * // Define um cookie 'auth' que expira em 7 dias
 * setCrossSubdomainCookie('auth', 'token123', 7);
 */
export const setCrossSubdomainCookie = (name: string, value: string, days: number): void => {
  const assign = name + '=' + encodeURIComponent(value) + ';';
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString() + ';';
  const path = 'path=/;';

  // Utiliza a função auxiliar para determinar o domínio
  let domain = 'domain=prev.app'; // Valor padrão em caso de erro

  try {
    domain = 'domain=' + getDomainFromHostname(window.location.hostname);
  } catch (error) {
    console.error('Erro ao determinar o domínio do cookie:', error);
    // Mantém o valor padrão 'domain=prev.app' em caso de erro
  }

  document.cookie = assign + expires + path + domain;
}
